export const selectedDataRowForTableDefaultState = [
  ["User"],
];

export const estimatedHoursDrillDownOtherActions = (
  key: string,
  currentDrillType: "site" | "course",
  setCurrentDrillType: React.Dispatch<React.SetStateAction<"site" | "course">>,
  selectedMonth: string | null,
  setSelectedDataRowForTable: React.Dispatch<React.SetStateAction<(string | string)[][]>>,
  setIsDrillDownLoading: React.Dispatch<React.SetStateAction<boolean>>,
  fetchDrillDownData?: (filters: any) => Promise<any>
) => {
  const toggleToSite = () => {
    if (currentDrillType !== "site" && selectedMonth && fetchDrillDownData) {
      setCurrentDrillType("site");
      fetchEstimatedHoursData(
        "site",
        selectedMonth,
        setSelectedDataRowForTable,
        setIsDrillDownLoading,
        fetchDrillDownData
      );
    }
  };

  const toggleToCourse = () => {
    if (currentDrillType !== "course" && selectedMonth && fetchDrillDownData) {
      setCurrentDrillType("course");
      fetchEstimatedHoursData(
        "course",
        selectedMonth,
        setSelectedDataRowForTable,
        setIsDrillDownLoading,
        fetchDrillDownData
      );
    }
  };

  return [
    {
      text: currentDrillType === "site" ? "By Course" : "By Site",
      action: currentDrillType === "site" ? toggleToCourse : toggleToSite,
      style: undefined as React.CSSProperties | undefined,
    },
  ];
}

export const showUserNamesOnRowSelect = (
  chartId: string,
  { chartWrapper }: any,
  data: any,
  setHoveredRowStye: React.Dispatch<React.SetStateAction<{ top?: number, left?: number, width?: string } | null>>,
  setSelectedDataRowForTable: React.Dispatch<React.SetStateAction<(string | string)[][]>>
) => {
  const chart = chartWrapper.getChart();
  const selection = chart.getSelection();
  if (selection.length > 0) {
    const row = selection[0].row;
    const rowData = (data?.data)[row + 1][0];
    
    const dataRows = data?.usersOnDates[rowData];

    if(dataRows) setSelectedDataRowForTable([
      ["Name"],
      ...dataRows,
    ])
    const targetElement = document.querySelector(`.${chartId}`);

    if (targetElement) {
      const rect = targetElement.getBoundingClientRect();
      // Calculate width based on number of columns (1 column for user names)
      const columnCount = 1;
      const columnWidth = 120; // Approximate width per column
      const calculatedWidth = Math.max(columnCount * columnWidth, 200); // Minimum 200px
      
      setHoveredRowStye({
        top: rect.top + (window.scrollY) + 200, // Adjust for scrolling
        left: rect.left + window.scrollX + rect.width, // Move to the right edge
        width: `${calculatedWidth}px`
      });
    }
  } else {
    setHoveredRowStye(null);
  }
}
const DRILLDOWN_SERIES = ["New Users", "Archived Users"];
const TOTAL_USERS_LABEL = "Total Users";

export const showMonthlyUserActivityOnRowSelect = (
  chartId: string,
  param: any,
  data: any,
  setHoveredRowStye: React.Dispatch<React.SetStateAction<{ top?: number, left?: number, width?: string } | null>>,
  setSelectedDataRowForTable: React.Dispatch<React.SetStateAction<(string | string)[][]>>
) => {
  const chartWrapper = param?.chartWrapper ?? param;
  const chart = chartWrapper?.getChart?.();
  const selection = chart?.getSelection?.() ?? [];
  if (selection.length > 0) {
    const row = selection[0].row;
    const column = selection[0].column;
    if(column === 1) {
      setHoveredRowStye(null);
      return;
    }
    const headers = data?.data?.[0];
    const rowLabel = data?.data?.[row + 1]?.[0];
    // Column chart: selection.column can be 0-based series index (0,1,2) or data column index (1,2,3).
    const candidates = (typeof column === "number" && headers)
      ? [headers[column + 1], headers[column]].filter(Boolean)
      : [];
    // Click on "Total Users" bar: do nothing and clear selection so bar doesn't stay highlighted
    if (candidates.includes(TOTAL_USERS_LABEL) && !candidates.some((s) => DRILLDOWN_SERIES.includes(s))) {
      chart?.setSelection?.([]);
      return;
    }
    if (column === 0) {
      chart?.setSelection?.([]);
      return;
    }
    let seriesLabels = candidates.filter((s) => DRILLDOWN_SERIES.includes(s));
    if (seriesLabels.length === 0 && typeof column === "number" && rowLabel) {
      if (column === 1) seriesLabels = [DRILLDOWN_SERIES[0]];
      else if (column === 2) seriesLabels = [DRILLDOWN_SERIES[0], DRILLDOWN_SERIES[1]];
      else if (column === 3) seriesLabels = [DRILLDOWN_SERIES[1]];
    }
    const key = rowLabel && seriesLabels.length > 0
      ? seriesLabels.map((seriesLabel) => `${rowLabel}|${seriesLabel}`).find((k) => {
          const arr = data?.usersOnDates?.[k];
          return Array.isArray(arr) && arr.length > 0;
        }) ?? (rowLabel && seriesLabels[0] ? `${rowLabel}|${seriesLabels[0]}` : null)
      : null;

    const dataRows = key ? data?.usersOnDates?.[key] : null;
    const rows = Array.isArray(dataRows) ? dataRows : [];

    if (key) {
      setSelectedDataRowForTable([["Name"], ...(rows.length ? rows : [["No users"]])]);
      const targetElement = document.querySelector(`.${chartId}`);
      const columnWidth = 120;
      const calculatedWidth = "200px";
      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        setHoveredRowStye({
          top: rect.top + window.scrollY + 200,
          left: rect.left + window.scrollX + rect.width,
          width: calculatedWidth,
        });
      } else {
        setHoveredRowStye({
          top: (window.scrollY ?? 0) + 200,
          left: (window.scrollX ?? 0) + 100,
          width: calculatedWidth,
        });
      }
    } else {
      setHoveredRowStye(null);
    }
  } else {
    setHoveredRowStye(null);
  }
}

export const showOrganisationCourseDetails = async (
  chartId: string,
  param: any,
  data: any,
  setHoveredRowStye: React.Dispatch<React.SetStateAction<{ top?: number, left?: number, width?: string } | null>>,
  setSelectedDataRowForTable: React.Dispatch<React.SetStateAction<(string | string)[][]>>,
  setIsDrillDownLoading: React.Dispatch<React.SetStateAction<boolean>>,
  fetchDrillDownData?: (organisationId: number) => Promise<any>
) => {
  // Extract row and rowIndex directly from the param
  const { row, rowIndex } = param;
  
  if (row && rowIndex !== undefined) {
    // Get the organisation ID from the row data
    // Assuming the organisation ID is in the second column (index 1)
    const organisationId = row[0];
    
    // Show the table immediately with loading state
    setSelectedDataRowForTable([
      ["Course Name", "Learners with Course", "Course Compliance %"],
      ["Loading...", "", ""]
    ]);

    // Show the hovered table immediately
    const targetElement = document.querySelector(`.${chartId}`);

    if (targetElement) {
      const rect = targetElement.getBoundingClientRect();
      // Calculate width based on number of columns (3 columns for course details)
      const columnCount = 3;
      const columnWidth = 120; // Approximate width per column
      const calculatedWidth = Math.max(columnCount * columnWidth, 500); // Minimum 300px
      
      setHoveredRowStye({
        top: rect.top + (window.scrollY) + 200, // Adjust for scrolling
        left: rect.left + window.scrollX + rect.width, // Move to the right edge
        width: `${calculatedWidth}px`
      });
    }
    const col = ["Course Name", /*"Learners with Course",*/ "Course Compliance %"];

    if (fetchDrillDownData && organisationId) {
      try {
        setIsDrillDownLoading(true);
        
        // Call the API to get drilldown data
        const drillDownResponse = await fetchDrillDownData(parseInt(organisationId));
        
        if (drillDownResponse?.data && drillDownResponse.data.length > 1) {
          // Remove the header row and format the data
          const courseData = drillDownResponse.data.slice(1);
          const formattedData = [
            col,
            ...courseData.map((course: any[]) => [
              course[0], // Course Name
              //course[1], // Learners with Course
              course[1] // Course Compliance %
            ])
          ];
          setSelectedDataRowForTable(formattedData);
        } else {
          setSelectedDataRowForTable([
            col,
            ["No course data available", ""]
          ]);
        }
      } catch (error) {
        console.error('Error fetching drilldown data:', error);
        setSelectedDataRowForTable([
          col,
          ["Error loading data", ""]
        ]);
      } finally {
        setIsDrillDownLoading(false);
      }
    } else {
      setSelectedDataRowForTable([
        col,
        ["No organisation ID available", ""]
      ]);
      setIsDrillDownLoading(false);
    }
  } else {
    setHoveredRowStye(null);
    setIsDrillDownLoading(false);
  }
}

export const showEstimatedHoursDrillDown = async (
  chartId: string,
  { chartWrapper }: any,
  data: any,
  setHoveredRowStye: React.Dispatch<React.SetStateAction<{ top?: number, left?: number, width?: string} | null>>,
  setSelectedDataRowForTable: React.Dispatch<React.SetStateAction<(string | string)[][]>>,
  setIsDrillDownLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setCurrentDrillType: React.Dispatch<React.SetStateAction<"site" | "course">>,
  setSelectedMonth: React.Dispatch<React.SetStateAction<string | null>>,
  fetchDrillDownData?: (filters: any) => Promise<any>
) => {
  const chart = chartWrapper.getChart();
  const selection = chart.getSelection();
  
  if (selection.length > 0) {
    const row = selection[0].row;
    const monthString = (data?.data)?.[row + 1]?.[0]; // Get month from first column
    
    if (monthString && fetchDrillDownData) {
      // Store selected month for toggle functionality
      setSelectedMonth(monthString);
      
      // Set default drill type to "course"
      setCurrentDrillType("course");
      
      // Show the table immediately with loading state
      setSelectedDataRowForTable([
        ["Course", "Total Hours"],
        ["Loading...", ""]
      ]);

      // Show the hovered table immediately
      const targetElement = document.querySelector(`.${chartId}`);

      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        // Calculate width based on number of columns (3 columns: Site/Course, Total Courses, Total Hours)
        const columnCount = 3;
        const columnWidth = 150; // Approximate width per column
        const calculatedWidth = Math.max(columnCount * columnWidth, 450); // Minimum 450px
        
        setHoveredRowStye({
          top: rect.top + (window.scrollY) + 200, // Adjust for scrolling
          left: rect.left + window.scrollX + rect.width, // Move to the right edge
          width: `${calculatedWidth}px`
        });
      }
      
      // Fetch initial data with "course" as default
      await fetchEstimatedHoursData("course", monthString, setSelectedDataRowForTable, setIsDrillDownLoading, fetchDrillDownData);
    } else {
      setHoveredRowStye(null);
      setIsDrillDownLoading(false);
    }
  } else {
    setHoveredRowStye(null);
    setIsDrillDownLoading(false);
  }
}

export const fetchEstimatedHoursData = async (
  drillType: "site" | "course",
  selectedMonth: string,
  setSelectedDataRowForTable: React.Dispatch<React.SetStateAction<(string | string)[][]>>,
  setIsDrillDownLoading: React.Dispatch<React.SetStateAction<boolean>>,
  fetchDrillDownData?: (filters: any) => Promise<any>
) => {
  if (!fetchDrillDownData) return;
  
  const col = drillType === "site" 
    ? ["Site", "Total Courses", "Total Hours"]
    : ["Course", "Total Hours"];
  
  try {
    setIsDrillDownLoading(true);
    
    // Call the API to get drilldown data
    // Backend expects lowercase: 'course' or 'site'
    const drillDownResponse = await fetchDrillDownData({
      estimatedHoursDrillDownBy: drillType,
      selectedMonth,
    });
    
    if (drillDownResponse?.data && Array.isArray(drillDownResponse.data) && drillDownResponse.data.length > 0) {
      // Format the data for display
      const formattedData = [
        col,
        ...drillDownResponse.data.map((item: any) => {
          if (drillType === "site") {
            return [
              item.name || item.title || 'No Site', // Site name
              item.totalCourses?.toString() || '0', // Total courses
              item.totalTime?.toString() || '0' // Total hours
            ];
          } else {
            return [
              item.title || item.name || 'No Course', // Course name
              item.totalTime?.toString() || '0' // Total hours
            ];
          }
        })
      ];
      setSelectedDataRowForTable(formattedData);
    } else {
      setSelectedDataRowForTable([
        col,
        drillType === "site" 
          ? ["No data available for this month", "", ""]
          : ["No data available for this month", ""]
      ]);
    }
  } catch (error) {
    console.error('Error fetching estimated hours drilldown data:', error);
    setSelectedDataRowForTable([
      col,
      drillType === "site" 
        ? ["Error loading data", "", ""]
        : ["Error loading data", ""]
    ]);
  } finally {
    setIsDrillDownLoading(false);
  }
}
